import { strings } from "../../../localization";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	GridItem,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useEffect } from "react";
import { FeedbackContainer, ScreenResponsive } from "../../../components";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { useNavigateCustom } from "../../../hooks";

export const ProcessingPendingChanges: React.FC = () => {
	const navigation = useNavigateCustom();
	const { authenticationStore } = useGlobalStore();
	const errorInfo = strings.components.connectionFeedback.errors;
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();


	const onLogoutPress = React.useCallback(
		() => {
			addAnalyticEvent({
				component: "body",
				action: "click.button",
				description: errorInfo.processingPendingChanges.buttons.primaryButton,
				step: "fgts:pendencias-com-a-conta",
				value: "",
			}, {applySanitize: true});
			authenticationStore.logout();
			navigation("/");
		},
		[],
	);

	useEffect(()=>{
		addAnalyticEvent({
			component: "body",
			action: "view-error",
			description: "pendencias-com-a-conta",
			step: "fgts:pendencias-com-a-conta",
			value: "",
			event: "non_interaction",
		}, {applySanitize: true});

		updatePageView({
			name: "Vivo Money FGTS Pendências com a Conta",
			pagePath: "/fgts/pendencias-com-a-conta",
		});
	},[]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<GridItem>
					<FeedbackContainer
						icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
						title={errorInfo.processingPendingChanges.title}
						description={errorInfo.processingPendingChanges.text}
					>
						<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
							<ButtonPrimary
								onPress={onLogoutPress}
								showSpinner={false}
								disabled={false}
								style={{ width: isDesktopOrBigger ? "auto" : "100%" }}
							>
								<Text3 medium color={skinVars.colors.textButtonPrimary}>
									{errorInfo.processingPendingChanges.buttons.primaryButton}
								</Text3>
							</ButtonPrimary>
						</ButtonLayout>
					</FeedbackContainer>
				</GridItem>
			</Grid>
		</ScreenResponsive>
	);
};

export default ProcessingPendingChanges;
